/**
 * 报表详情
 * date:2022 07 25
 * author：brian

 */
import httpRequest from '@/utils/request.js'

/** 获取监测点分页查询 */
export const detailList = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/detail/data/lst',
    params: {
      ...params
    }
  })
/** 获取监测点详细数据 */
export const detaiIds = id =>
  httpRequest.httpGet({
    url: '/service/detail/data/getCarrier/' + id
  })
/** 查询传感器历史数据 */
export const dataHistory = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/detail/data/history',
    params: {
      ...params
    }
  })
/** 导出 */
export const exportDatas = data =>
  httpRequest.httpPost('/service/detail/data/export', data)

// 详细数据异常情况
export const exSituationAnal = params =>
  httpRequest.httpGet({
    url: '/service/detail/data/ex',
    params
  })

// 详细数据导出
export const detailDataExport = data =>
  httpRequest.httpPost('/service/detail/data/export2', data)
